module.exports = __webpack_public_path__ + "img/gulp.9b6fcff3.png";